import { render, staticRenderFns } from "./RegistrationLookupComponent.vue?vue&type=template&id=0f15a3a0"
import script from "./RegistrationLookupComponent.vue?vue&type=script&lang=ts"
export * from "./RegistrationLookupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports